/**
 * @generated SignedSource<<65b87973d45660c976e4f7e8f63706dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlightPrice_flight$data = {
  readonly isUpdating: boolean;
  readonly priceLive: number;
  readonly " $fragmentType": "PackageDateRowFlightPrice_flight";
};
export type PackageDateRowFlightPrice_flight$key = {
  readonly " $data"?: PackageDateRowFlightPrice_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightPrice_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlightPrice_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceLive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUpdating",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "9c6c4cac37fdb6f022653bc4b25b202a";

export default node;
